/* The DJ Hookup: load optional storefront apps on actual user input. */
(function () {
  'use strict';
  if (window.DJHSpeedApps) return;
  const element = document.getElementById('SpeedAppsConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const loaded = new Map();
  const groups = new Map();
  let rewardsPending = false;
  const triggers = ['pointerdown', 'touchstart', 'wheel', 'keydown'];

  function loadScript(definition) {
    if (loaded.has(definition.src)) return loaded.get(definition.src);
    const promise = new Promise(function (resolve, reject) {
      const script = document.createElement('script');
      // Dependencies are awaited within their own group; independent apps stay parallel.
      script.async = true;
      if (definition.id) script.id = definition.id;
      Object.entries(definition.attrs || {}).forEach(function ([key, value]) {
        script.setAttribute(key, value);
      });
      script.onload = resolve;
      script.onerror = function () {
        script.remove();
        loaded.delete(definition.src);
        reject(new Error('Optional app script failed to load: ' + definition.src));
      };
      script.src = definition.src;
      document.head.appendChild(script);
    });
    loaded.set(definition.src, promise);
    return promise;
  }

  function loadGroup(group) {
    if (groups.has(group.name)) return groups.get(group.name);
    const promise = (async function () {
      for (const script of group.scripts) await loadScript(script);
      document.dispatchEvent(new CustomEvent('djh:app-loaded', { detail: { name: group.name } }));
    })().catch(function (error) {
      groups.delete(group.name);
      document.dispatchEvent(new CustomEvent('djh:app-error', { detail: { name: group.name } }));
      throw error;
    });
    groups.set(group.name, promise);
    return promise;
  }

  function load(name) {
    return Promise.allSettled(config.groups.filter(function (group) {
      return !name || group.name === name;
    }).map(loadGroup));
  }

  function onInput(event) {
    if (!event.isTrusted) return;
    triggers.forEach(function (type) { document.removeEventListener(type, onInput, true); });
    load().then(function (results) {
      if (results.some(function (result) { return result.status === 'rejected'; })) listenForInput();
    });
  }

  function listenForInput() {
    triggers.forEach(function (type) {
      document.addEventListener(type, onInput, { capture: true, passive: true });
    });
  }

  function openRewards() {
    if (window.okeLoyaltyApi && typeof window.okeLoyaltyApi.open === 'function') {
      window.okeLoyaltyApi.open();
      return;
    }
    if (!rewardsPending) {
      rewardsPending = true;
      document.addEventListener('oke-loyalty-widget-loaded', function ready() {
        document.removeEventListener('oke-loyalty-widget-loaded', ready);
        rewardsPending = false;
        if (window.okeLoyaltyApi) window.okeLoyaltyApi.open();
      });
    }
    load('loyalty');
  }

  window.DJHSpeedApps = { load: load, openRewards: openRewards };
  listenForInput();
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !event.target.closest('.open-cue-rewards')) return;
    event.preventDefault();
    openRewards();
  });
  // Direct links are explicit user intent, and the vendor owns modal opening.
  if (window.location.hash === '#rewards' || /[?&]okendo_loyalty_open=true(?:&|$)/.test(window.location.search)) {
    openRewards();
  }
})();
